
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { Message } from 'element-ui';

@Component({
  name: "PortraitList"
})
export default class PortraitList extends Vue {
  // 搜索表单数据
  searchForm = {
    userName: '',
    mobile: ''
  };

  // 表格数据
  tableData: any[] = [];
  loading = false;
  currentPage = 1;
  pageSize = 10;
  total = 0;

  // 组件挂载时获取数据
  mounted() {
    this.getTableData();
  }

  // 获取表格数据
  async getTableData() {
    this.loading = true;

    try {
      const params = {
        userName: this.searchForm.userName,
        mobile: this.searchForm.mobile,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };

      // 通过Vuex dispatch调用store中的action
      const res: any = await store.dispatch('portrait/getUserPortraitList', params);

      // 添加调试信息，查看返回的数据结构
      console.log('API Response:', res);
      if (res.code === '0' && res.data && res.data.list) {
        console.log('Table Data Structure:', res.data.list[0]); // 查看第一条数据的结构
      }

      if (res.code === '0') {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else {
        Message.error(res.msg || '获取用户画像列表失败');
        this.tableData = [];
        this.total = 0;
      }
    } catch (error) {
      Message.error('获取用户画像列表失败: ' + (error as any).message);
      this.tableData = [];
      this.total = 0;
    } finally {
      this.loading = false;
    }
  }

  // 查询
  handleSearch() {
    this.currentPage = 1;
    this.getTableData();
  }

  // 重置
  handleReset() {
    this.searchForm.userName = '';
    this.searchForm.mobile = '';
    this.currentPage = 1;
    this.getTableData();
  }

  // 查看画像详情
  handleView(row: any, rowIndex?: number) {
    // 传递用户ID、手机号、当前页码及点击的行号信息
    // 使用window.open打开新页面
    const queryParams = new URLSearchParams({
      mobile: row.mobile || '',
      page: this.currentPage.toString(),
      rowIndex: rowIndex !== undefined ? rowIndex.toString() : ''
    }).toString();

    // 使用手机号作为详情页的标识符，如果手机号不存在则使用索引
    const url = `/portrait/detail?${queryParams}`;
    window.open(url, '_blank');
  }

  // 分页相关
  handleSizeChange(val: number) {
    this.pageSize = val;
    this.currentPage = 1;
    this.getTableData();
  }

  handleCurrentChange(val: number) {
    this.currentPage = val;
    this.getTableData();
  }
}
